<template>
  <v-app id="inspire" :dark="$store.state.darkTheme">
    <v-navigation-drawer v-model="leftDrawerOpen" :clipped="$vuetify.breakpoint.lgAndUp" disable-resize-watcher fixed app style="z-index:101">
      <master-nav-left />
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" dark app fixed
               height="54px" class="hiddeNavigation" color="primary" style="z-index:100"
    >
      <v-toolbar-side-icon @click.stop="leftDrawerOpen = !leftDrawerOpen" />
      <v-toolbar-title style="width: 350px" class="ml-0">
        <!-- <span> -->
        <component :is="toolbarTitle" class="toolbar-title" />
        <!-- </span> -->
      </v-toolbar-title>
      <v-text-field v-model="search" prepend-inner-icon="search" flat solo-inverted hide-details single-line
                    label="Buscar Incidencia" class="hidden-xs-only small-control"
                    @keyup.native="searchIncidencia" @click:prepend-inner="searchIncidencia(null)"
      />
      <v-spacer />
      <v-spacer />
      <!-- <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
       -->
      <div>
        <v-tabs color="primary" right icons-and-text height="54px" class="toobarTabs">
          <v-tooltip v-if="isTecnico" bottom class="maximized-child-content">
            <template v-slot:activator="{ on }">
              <v-tab v-on="on" @click.stop="showInstalaciones">
                <v-icon class="px-1 mb-0" large>
                  mdi-information-outline
                </v-icon>
              </v-tab>
            </template>
            <span>Instalaciones</span>
          </v-tooltip>
          <v-tooltip bottom class="maximized-child-content">
            <template v-slot:activator="{ on }">
              <v-tab :to="{name: 'incidenciasEdit', params: { clienteProp: 'new', instalacionProp: new Date().getTime() }}" v-on="on">
                <v-icon class="px-1 mb-0" large>
                  mdi-plus-circle-outline
                </v-icon>
              </v-tab>
            </template>
            <span>Crear Incidencia</span>
          </v-tooltip>
          <!--
          <v-tooltip bottom class="maximized-child-content">
            <template v-slot:activator="{ on }">
              <v-tab :to="{name: 'ClientesEdit', params: { clienteProp: 'new' }}" v-on="on">
                <v-icon class="px-1 mb-0" large>
                  mdi-account-plus-outline
                </v-icon>
              </v-tab>
            </template>
            <span>Añadir Cliente</span>
          </v-tooltip>
          -->
          <v-tooltip v-if="isTecnico" bottom class="maximized-child-content">
            <template v-slot:activator="{ on }">
              <v-tab v-on="on" @click.stop="showHelp">
                <v-icon class="px-1 mb-0" large>
                  mdi-help-circle-outline
                </v-icon>
              </v-tab>
            </template>
            <span>Ayuda</span>
          </v-tooltip>
        </v-tabs>
      </div>
    </v-toolbar>

    <v-content id="container">
      <router-view ref="routerView" :key="$route.path" />
    </v-content>

    <inner-loading :visible="$store.state.innerLoading" />
    <component :is="floatingActions" v-if="isTecnico" />

    <confirm ref="confirm" />

    <mini-modal ref="modal" />
    <instalaciones ref="dialogInstalaciones" />
    <ayuda ref="dialogHelp" />
  </v-app>
</template>

<script>
import AddIncidencias from '@/components/floatingActions/incidencias/Add'
import InnerLoading from '@/components/InnerLoading'
import MiniModal from '@/components/MiniModal.vue'
import Instalaciones from '@/pages/instalaciones/index.vue'
import Confirm from '@/components/Confirm.vue'
import { EventBus } from '@/store/EventBus.js'
import MasterNavLeft from './MasterNavLeft.vue'
import Ayuda from '@/pages/ayuda/index.vue'
import store from '@/store/index.js'

export default {
  name: 'Master',
  components: { MasterNavLeft, MiniModal, Confirm, InnerLoading, Instalaciones, Ayuda },
  data () {
    return {
      profile: store.getters['getProfile'],
      // leftDrawerOpen: this.$q.platform.is.desktop,
      leftDrawerOpen: false,
      toolbarTitle: {
        template: `<span>${this.$config.AppName}</span>`
      },
      floatingActions: AddIncidencias,
      search: '',
      time: null,
      searchWarning: false,
      isTecnico: false
    }
  },
  watch: {
    '$route' (to, from) {
      if (from.query.back) {
        if (this.$refs.modal && this.$refs.modal.maximized) { this.$refs.modal.closeModal(true) }
        if (this.$refs.dialogInstalaciones) { this.$refs.dialogInstalaciones.close(true) }
        if (this.$refs.dialogHelp) { this.$refs.dialogHelp.close(true) }
      }
    }
  },
  created () {
    EventBus.$on('newToolbarTitle', (toolbarTitleComponent) => {
      this.search = ''
      this.toolbarTitle = toolbarTitleComponent
    })
    EventBus.$on('showModal', ({ component, props }) => { this.showModal(component, props) })
    EventBus.$on('newFloatingActions', (component) => {
      // this.floatingActions = component || AddIncidencias
    })
  },
  beforeDestroy () {
    EventBus.$off('newToolbarTitle')
    EventBus.$off('showModal')
    EventBus.$off('newFloatingActions')
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm
    this.getRol()
  },
  methods: {
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    },
    incidenciasNew () {
      let routeData = this.$router.resolve({ name: 'incidenciasEdit',
        params: { clienteProp: 'new', instalacionProp: new Date().getTime() } })
      return routeData.resolved.fullPath
    },
    showInstalaciones () {
      if (this.$refs.dialogInstalaciones) this.$refs.dialogInstalaciones.show()
    },
    showHelp () {
      if (this.$refs.dialogHelp) this.$refs.dialogHelp.show()
    },
    showModal (component, props) {
      if (this.$refs.modal) { this.$refs.modal.show(component, props) }
    },
    searchIncidencia (event) {
      this.searchWarning = false
      if ((!event || event.keyCode === 13) && this.search) {
        let val = this.search.split('/')
        let cliente = Number(val[0])
        let instalacion = Number(val[1])
        let incidencia = Number(val[2])
        if (this.search.split('/').length < 3 && this.$refs.routerView &&
         this.$refs.routerView.filters && this.$refs.routerView.filters.Cliente) {
          cliente = this.$refs.routerView.filters.Cliente
          instalacion = Number(val[0])
          incidencia = Number(val[1])
          if (this.search.split('/').length < 2 && this.$refs.routerView.filters.Instalacion) {
            instalacion = this.$refs.routerView.filters.Instalacion.split('/').pop()
            incidencia = Number(val[0])
          }
        }
        if (cliente && instalacion && incidencia) {
          this.$router.push({ name: 'incidenciasEdit',
            params: { clienteProp: cliente, instalacionProp: instalacion, incidenciaProp: incidencia }
          })
        } else { this.searchWarning = true }
        // else if (val.length < 3 && !this.search.endsWith('/')) this.search += '/'
      }
    }
  }
}

</script>

<style>
.toolbarTitle {
  height: inherit;
  line-height: 32px;
  padding-top: 3px;
  min-width: 300px !important;
}
.toolbarTabs .q-tab-icon {
  font-size: 25px;
}
.toolbarTabs .q-chip {
  background-color: #db2828;
}
.toolbarTabs .q-tab-label {
  font-size: 0.85rem;
}

@media print {
  .hiddeNavigation {
    display: none;
  }
}
</style>
